/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

// Absolute import
import React from 'react';
import PropTypes from 'prop-types';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { connect } from 'react-redux';
// Relative import
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../../assets/styles/style.sass';
import s2 from '../Order.sass';
import {
  addOrderImage,
  updateOrderImage,
  removeOrderImage,
} from '../../../actions/order';

const imageInitValue = {};
class Order13RemarksAddPhoto extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    addImageComponent: PropTypes.func.isRequired,
    removeImageComponent: PropTypes.func.isRequired,
    addOrderImage: PropTypes.func.isRequired,
    updateOrderImage: PropTypes.func.isRequired,
    removeOrderImage: PropTypes.func.isRequired,
    setIsImgTooLarge: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      image: imageInitValue,
    };
    this.onClickUpdateImage = this.onClickUpdateImage.bind(this);
    this.onClickCancelImage = this.onClickCancelImage.bind(this);
    this.readFile = this.readFile.bind(this);
    this.searchIndex = this.searchIndex.bind(this);
  }

  onClickUpdateImage() {
    this.image.click();
  }

  onClickCancelImage() {
    const index = this.searchIndex(this.state.image.base64);
    this.setState({ image: imageInitValue });
    this.props.removeImageComponent(index);
    this.props.removeOrderImage(index);
  }

  readFile(e) {
    const file = e.target.files[0];
    if (file !== null && typeof file !== 'undefined') {
      if (file.size > 2000000) {
        this.props.setIsImgTooLarge(true);
      } else {
        this.props.setIsImgTooLarge(false);
        const FR = new FileReader();
        FR.onload = event => {
          const base64 = event.target.result;
          // ensure no duplicate photo
          if (this.searchIndex(base64) !== -1) {
            return null;
          }
          FR.abort();
          const FR2 = new FileReader();
          FR2.onload = es => {
            const image = {
              // image base64 format
              base64,
              // text & type for upload to server
              text: es.target.result,
              type: file.type,
            };

            // new image
            if (Object.keys(this.state.image).length === 0) {
              this.props.updateOrderImage(image, this.props.images.length - 1);
              this.props.addOrderImage(imageInitValue);
              this.props.addImageComponent(false);
            } else {
              this.props.updateOrderImage(
                image,
                this.searchIndex(this.state.image.base64),
              );
            }
            this.setState({
              image,
            });
          };
          FR2.readAsText(file);
          return true;
        };
        FR.readAsDataURL(file);
      }
    }
  }

  searchIndex(image) {
    for (let i = 0; i < this.props.images.length; i += 1) {
      if (this.props.images[i].base64 === image) {
        return i;
      }
    }
    return -1;
  }

  render() {
    return (
      <span>
        <input
          ref={input => {
            this.image = input;
          }}
          type="file"
          className={`${s2.uploadFile}`}
          onChange={this.readFile}
          accept="image/*"
        />
        <span
          className={`${s2.imageItem}`}
          role="button"
          tabIndex={0}
          onClick={e => {
            e.preventDefault();
            this.onClickUpdateImage();
          }}
          onKeyPress={() => {}}
        >
          <span
            className={
              Object.keys(this.state.image).length === 0
                ? ''
                : s2.imageItemCancel
            }
            role="button"
            tabIndex={0}
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              this.onClickCancelImage();
            }}
            onKeyPress={() => {}}
          />
          <span
            className={`${s2.uploadImage}`}
            style={
              Object.keys(this.state.image).length === 0
                ? {}
                : { backgroundImage: `url(${this.state.image.base64})` }
            }
          />
        </span>
      </span>
    );
  }
}
const mapState = state => ({
  images: state.order.images,
});

const mapDispatch = {
  addOrderImage,
  updateOrderImage,
  removeOrderImage,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(Order13RemarksAddPhoto),
);



// WEBPACK FOOTER //
// ./src/routes/order/Order13Remarks/Order13RemarksAddPhoto.js